import { useEffect, useRef } from 'react'

import { useRecoilCallback, useRecoilValue } from 'recoil'

import { panelAddRecipientState } from 'Pages/RecipientsList/recoil/state/addRecipient'
import { panelConfigColumnsState } from 'Pages/RecipientsList/recoil/state/configColumns'
import { panelEditRecipientState } from 'Pages/RecipientsList/recoil/state/recipient'

import { panelAddRecipientCloseCallback } from 'Pages/RecipientsList/recoil/callbacks/addRecipient'
import { panelConfigColumnsCloseCallback } from 'Pages/RecipientsList/recoil/callbacks/configColumns'
import { panelEditRecipientCloseCallback } from 'Pages/RecipientsList/recoil/callbacks/recipient'

const usePanelsCoordinator = (): void => {
  const bodyOverflowRef = useRef('')

  const { show: showEditRecipient } = useRecoilValue(panelEditRecipientState)
  const { show: showAddRecipient } = useRecoilValue(panelAddRecipientState)
  const { show: showConfigColumns } = useRecoilValue(panelConfigColumnsState)

  const closeEditRecipient = useRecoilCallback(
    panelEditRecipientCloseCallback,
    [],
  )
  const closeAddRecipient = useRecoilCallback(
    panelAddRecipientCloseCallback,
    [],
  )

  const closeConfigColumns = useRecoilCallback(
    panelConfigColumnsCloseCallback,
    [],
  )

  useEffect(() => {
    if (showEditRecipient) {
      void closeAddRecipient()
      void closeConfigColumns()
    }
  }, [showEditRecipient])

  useEffect(() => {
    if (showAddRecipient) {
      void closeEditRecipient()
      void closeConfigColumns()
    }
  }, [showAddRecipient])

  useEffect(() => {
    if (showConfigColumns) {
      void closeAddRecipient()
      void closeEditRecipient()
      //
      bodyOverflowRef.current = document.body.style.overflowY
      document.body.style.overflowY = 'hidden'
    }

    return () => {
      if (showConfigColumns) {
        document.body.style.overflowY = bodyOverflowRef.current
      }
    }
  }, [showConfigColumns])
}

export default usePanelsCoordinator
